export default "__VITE_PUBLIC_ASSET__e785b468__"